import React from "react";
import { useReceivableModel } from "../receivableModel";

import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useReceivableModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const { getSelectedDictOne } = useDictModel();
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Statistic Analysis"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Receivable Amount"]}</span>
        {/* <span style={{ color: "#7F7F7F" }}>{"统计分析"} </span>
        <span style={{ color: "#000" }}>/ {"出入汇总表"}</span> */}
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "单据编号",
            placeholder: Locale["Document No."],
            fieldName: "tradeCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "单据类型",
            placeholder: Locale["Document  Type"],
            fieldName: "tradeTypeCode",
            size: "small",
            // options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
            // options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE)
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE).filter(item => item.value === "trade-type.maintenance" || item.value === "trade-type.purchase-return" || item.value === "trade-type.sale")
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "客户名称",
            placeholder: Locale["Customer"],
            fieldName: "userName",
            size: "small",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName:"",
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },

    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}